import React from 'react';
import './style.css';

const Loader2 = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader2;